var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_37_1673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7049 -0.00011426C11.7882 0.0104026 9.44444 2.43628 9.44444 5.381V7.85245H1.66667C0.746528 7.85245 0 8.60616 0 9.53514V16.2659C0 17.1949 0.746528 17.9486 1.66667 17.9486H13.8889C14.809 17.9486 15.5556 17.1949 15.5556 16.2659V9.53514C15.5556 8.60616 14.809 7.85245 13.8889 7.85245H12.2222V5.35996C12.2222 3.97174 13.3229 2.8184 14.6979 2.80437C16.0868 2.79035 17.2222 3.92967 17.2222 5.32841V8.1329C17.2222 8.59914 17.5938 8.97424 18.0556 8.97424H19.1667C19.6285 8.97424 20 8.59914 20 8.1329V5.32841C20 2.3837 17.6215 -0.0106311 14.7049 -0.00011426Z",
    fill: "#00D27E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_1673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.9487,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingStatus);
export default __webpack_public_path__ + "static/media/pending-status.c9b607a59a6de38fed3a7446d3e31ef2.svg";
export { ForwardRef as ReactComponent };